import React, { useEffect, useState, useMemo } from "react";
import { GetConstructionOrderApi } from "./ConstructionOrderAction";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { useTranslation } from "react-i18next";
import { getCategoryData } from "../../AddDetails/categories/Catagory.action";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import { baseURL } from "../../../../../global/api";


// ─── Status Config ─────────────────────────────────────────────────────────────
const STATUS_CONFIG = {
    Completed: { color: "#059669", bg: "#d1fae5", icon: "✓" },
    Pending: { color: "#d97706", bg: "#fef3c7", icon: "◷" },
    Cancelled: { color: "#dc2626", bg: "#fee2e2", icon: "✕" },
    Processing: { color: "#6366f1", bg: "#ede9fe", icon: "⟳" },
};
function getStatusCfg(status) {
    return STATUS_CONFIG[status] ?? { color: "#6b7280", bg: "#f3f4f6", icon: "•" };
}
const fmt = (n) => Number(n ?? 0).toLocaleString("en-PK", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = (d) => {
    if (!d) return "—";
    const date = new Date(d);
    return isNaN(date) ? d : date.toLocaleDateString("en-PK", { day: "2-digit", month: "short", year: "numeric" });
};
const role = localStorage.getItem("role");

// ─── Order Detail Page ─────────────────────────────────────────────────────────
function OrderDetailPage({ order, onBack }) {
    const { t } = useTranslation();
    const cfg = getStatusCfg(order.status);
    const remaining = (order.finalTotal ?? 0) - (order.advance ?? 0);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const filteredProductExpenses = selectedCategoryId ? order.productExpenseData?.filter(p => p.categoryId?._id === selectedCategoryId) : order.productExpenseData;
    const filteredServiceExpenses = selectedCategoryId ? order.extraServiceExpenseData?.filter(e => e.categoryId?._id === selectedCategoryId) : order.extraServiceExpenseData;


    const productTotal = (filteredProductExpenses || []).reduce(
        (sum, item) => sum + Number(item.totalSalePrice || 0),
        0
    );
    const serviceTotal = (filteredServiceExpenses || []).reduce(
        (sum, item) => sum + Number(item.total || 0),
        0
    );

    const expensesTotal = productTotal + serviceTotal;

    return (
        <div style={s.page}>
            <main style={{ ...s.main, maxWidth: 'auto' }}>
                <button onClick={onBack} style={s.backBtn}>← Back to Orders</button>

                <div style={s.detailHeader}>
                    <div style={{ flex: 1 }}>
                        <p style={s.detailMeta}>{t("Order")}</p>
                        <h2 style={s.detailTitle}>
                            #{order.sequenceNumber ?? "—"}
                            <span style={{ ...s.badge, color: cfg.color, background: cfg.bg, marginLeft: 14 }}>
                                {cfg.icon} {order.status}
                            </span>
                        </h2>
                        <p style={s.detailSub}> {t("Customer")} <strong>{order.customerDetails?.name ?? "—"}</strong>
                            {/* &nbsp;·&nbsp;Created by: <strong>{order.userDetails?.userName ?? "—"}</strong> */}
                        </p>
                    </div>
                    <div style={s.totalBox}>
                        <p style={s.totalBoxLabel}>{t("Order Profit")}</p>
                        <p style={s.totalBoxAmount}>{role === "admin" ? fmt(order.finalTotal) : "*****"}</p>
                        {/* <p style={{ ...s.totalBoxLabel, marginTop: 6 }}>Balance Due</p> */}
                        {/* <p style={{ ...s.totalBoxAmount, fontSize: 16, color: remaining > 0 ? "#dc2626" : "#059669" }}>{fmt(remaining)}</p> */}
                    </div>
                </div>

                <div style={s.infoGrid}>
                    {[
                        [t("Date"), fmtDate(order.date)],
                        [t("DeliveryDate"), fmtDate(order.deliveryDate)],
                        [t("SellingPrice"), " " + (role === "admin" ? fmt(order.sellingPrice) : "*****")],
                        [t("Expense"), " " + (role === "admin" ? fmt(order.totalExpense) : "*****")],
                    ].map(([label, val]) => (
                        <div key={label} style={s.infoField}>
                            <p style={s.fieldLabel}>{label}</p>
                            <p style={s.fieldValue}>{val}</p>
                        </div>
                    ))}
                </div>

                {order.categories?.length > 0 && (
                    <div style={s.section}>
                        <p style={s.sectionTitle}>{t("Category")}</p>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            <span
                                onClick={() => setSelectedCategoryId(null)}
                                style={{
                                    ...s.catChip,
                                    cursor: "pointer",
                                    background: selectedCategoryId === null ? "#3b82f6" : "#eff6ff",
                                    color: selectedCategoryId === null ? "#fff" : "#3b82f6",
                                }}
                            >
                                All
                            </span>
                            {order.categories.map((c, i) => (
                                <span
                                    key={i}
                                    onClick={() => setSelectedCategoryId(prev => prev === c._id ? null : c._id)}
                                    style={{
                                        ...s.catChip,
                                        cursor: "pointer",
                                        background: selectedCategoryId === c._id ? "#3b82f6" : "#eff6ff",
                                        color: selectedCategoryId === c._id ? "#fff" : "#3b82f6",
                                    }}
                                >
                                    {c.name}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {filteredProductExpenses?.length > 0 && (
                    <div style={s.section}>
                        <p style={s.sectionTitle}>{t("Package Expenses")}</p>
                        <div style={s.tableWrap}>
                            <table style={s.table}>
                                <thead>
                                    <tr>{["Category", "Package", "Qty", "Sale Price", "Total"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
                                </thead>
                                <tbody>
                                    {filteredProductExpenses?.map((p, i) => (
                                        <tr key={i} style={i % 2 ? { background: "#f8fafc" } : {}}>
                                            <td style={s.td}>{p.categoryId.name}</td>
                                            <td style={s.td}>{p.productName}</td>
                                            <td style={s.td}>{p.quantity}</td>
                                            <td style={s.td}>{(role === "admin" ? fmt(p.salePrice) : '****')}</td>
                                            <td style={{ ...s.td, fontWeight: 700 }}>{(role === "admin" ? fmt(p.totalSalePrice) : '****')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                {(filteredProductExpenses || []).length > 0 && (
                                    <tr style={{ background: "#eef2ff" }}>
                                        <td colSpan={4} style={{ ...s.td, fontWeight: 700, textAlign: "right" }}>
                                            Total
                                        </td>
                                        <td style={{ ...s.tdHighlight }}>
                                            {role === "admin" ? fmt(productTotal) : "****"}
                                        </td>
                                    </tr>
                                )}
                            </table>
                        </div>
                    </div>
                )}

                {filteredServiceExpenses?.length > 0 && (
                    <div style={s.section}>
                        <p style={s.sectionTitle}>{t("Extra Service Expenses")}</p>
                        <div style={s.tableWrap}>
                            <table style={s.table}>
                                <thead>
                                    <tr>{["Category", "Date", "Invoice No", "Supplier", "VATIN", "Description", "Amount", "VAT %", "Total", "File",].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
                                </thead>
                                <tbody>
                                    {filteredServiceExpenses?.map((e, i) => (
                                        <tr key={i} style={i % 2 ? { background: "#f8fafc" } : {}}>
                                            <td style={s.td}>{e.categoryId.name}</td>
                                            <td style={s.td}>{e.date}</td>
                                            <td style={s.td}>{e.invoiceNo}</td>
                                            <td style={s.td}>{e.supplierName}</td>
                                            <td style={s.td}>{e.vatinNo}</td>
                                            <td style={s.td}>{e.description}</td>
                                            <td style={s.td}>{(role === "admin" ? fmt(e.amount) : '****')}</td>
                                            <td style={s.td}>{(role === "admin" ? fmt(e.vat) : '****')}</td>
                                            <td style={{ ...s.td, fontWeight: 700 }}>{(role === "admin" ? fmt(e.total) : '****')}</td>
                                            <td style={s.td}>
                                                {e.uploader ? (
                                                    <a
                                                        href={`${baseURL}/assets/${e.uploader}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            color: "#2563eb",
                                                            fontWeight: 600,
                                                            textDecoration: "none",
                                                        }}
                                                    >
                                                        View File
                                                    </a>
                                                ) : (
                                                    "—"
                                                )}
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                                {(filteredServiceExpenses || []).length > 0 && (
                                    <tr style={{ background: "#eef2ff" }}>
                                        <td colSpan={9} style={{ ...s.td, fontWeight: 700, textAlign: "right" }}>
                                            Total
                                        </td>
                                        <td style={{ ...s.tdHighlight }}>
                                            {role === "admin" ? fmt(serviceTotal) : "****"}
                                        </td>
                                    </tr>
                                )}
                            </table>
                        </div>
                    </div>
                )}

                <div style={s.summaryBox}>
                    {[
                        [t("SellingPrice"), role === "admin" ? fmt(order.sellingPrice) : "*****", false],
                        [t("Package Expenses"), role === "admin" ? fmt(productTotal) : '*****', false],
                        [t("Extra Service Expenses"), role === "admin" ? fmt(serviceTotal) : '*****', false],
                        // [t("VAT"), fmt(order.vatTotal), false],
                        [t("FinalTotal"), role === "admin" ? fmt(order.sellingPrice - expensesTotal) : "*****", true],
                    ].map(([label, val, bold], i) => (
                        <div key={label} style={{
                            ...s.summaryRow,
                            borderTop: bold ? "2px solid #e5e7eb" : "none",
                            paddingTop: bold ? 10 : 0,
                            fontWeight: bold ? 700 : 500,
                            fontSize: bold ? 16 : 14,
                            color: label === "Balance Due" ? (remaining > 0 ? "#dc2626" : "#059669") : "#1e293b",
                        }}>
                            <span>{label}</span>
                            <span>{val}</span>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
}

// ─── Order Card ────────────────────────────────────────────────────────────────
function OrderCard({ order, onClick }) {
    const { t } = useTranslation();
    const [hovered, setHovered] = useState(false);
    const cfg = getStatusCfg(order.status);
    const productCount = order.productExpenseData?.length ?? 0;
    const serviceCount = order.extraServiceExpenseData?.length ?? 0;
    const cats = order.categories?.map(c => c.name).join(", ") || "—";

    return (
        <div
            onClick={() => onClick(order)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                ...s.card,
                transform: hovered ? "translateY(-5px)" : "translateY(0)",
                boxShadow: hovered ? "0 14px 36px rgba(0,0,0,0.13)" : "0 2px 8px rgba(0,0,0,0.07)",
            }}
        >
            <div style={{ height: 4, background: cfg.color, borderRadius: "14px 14px 0 0" }} />
            <div style={{ padding: "14px 18px 16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div>
                        <p style={s.seqLabel}>{t("Order")}</p>
                        <p style={s.seqNum}>#{order.sequenceNumber ?? "—"}</p>
                    </div>
                    <span style={{ ...s.badge, color: cfg.color, background: cfg.bg }}>
                        {cfg.icon} {order.status}
                    </span>
                </div>
                <p style={s.customerName}>{order.customerDetails?.name ?? "—"}</p>
                <p style={s.catText} title={cats}>{cats.length > 32 ? cats.slice(0, 32) + "…" : cats}</p>
                <div style={s.dateRow}>
                    <span style={s.dateChip}>📅 {fmtDate(order.date)}</span>
                    <span style={s.dateChip}>🚚 {fmtDate(order.deliveryDate)}</span>
                </div>
                <div style={s.countRow}>
                    <span style={s.countChip}>{productCount} package{productCount !== 1 ? "s" : ""}</span>
                    <span style={s.countChip}>{serviceCount} service{serviceCount !== 1 ? "s" : ""}</span>
                </div>
                <div style={s.divider} />
                <div style={s.financials}>
                    <div>
                        <p style={s.finLabel}>{t("SellingPrice")}</p>
                        <p style={s.finAmount}>{role === "admin" ? fmt(order.sellingPrice) : "*****"}</p>
                    </div>
                    <div style={{ textAlign: "right" }}>
                        <p style={s.finLabel}>{t("Expense")}</p>
                        <p style={{ ...s.finAmount, fontSize: 14, color: "#059669" }}>{role === "admin" ? fmt(order.totalExpense) : "*****"}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Dashboard ─────────────────────────────────────────────────────────────────
const ConstructionOrderDashboard = (props) => {
    const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [search, setSearch] = useState("");
    const [categories, setCategories] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");


    const handleCategoryChange = (selected) => {
        const formatted = selected ? selected.map((item) => ({
            _id: item.value,
            name: item.label,
        })) : [];
        setCategories(formatted);
    };
    const categoryOptions = useMemo(() => {
        return props.categoryList?.data?.map((item) => ({
            value: item._id,
            label: item.name,
        })) || [];
    }, [props.categoryList]);
    const selectedOptions = useMemo(() => {
        return categoryOptions.filter((opt) => categories.some((c) => c._id === opt.value));
    }, [categories, categoryOptions]);

    useEffect(() => {
        props.GetConstructionOrderApi()
        props.getCategoryData()
        props.setHeading("Construction Order Dashboard")
    }, []);

    useEffect(() => {
        if (props.constructionOrderDataList) {
            setOrders(props.constructionOrderDataList);
            setLoading(false);
        }
    }, [props.constructionOrderDataList]);

    if (props.isFetchingcategoryList || props.isFetchingConstructionOrder) {
        return (
            <div
                className="loader-div"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Spinner
                    variant="primary"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                    style={{ width: "3rem", height: "3rem" }}
                />
            </div>
        );
    }

    const filtered = orders.filter(o => {
        if (!o.enable) return false;

        const matchSearch =
            String(o.sequenceNumber ?? "").includes(search) ||
            (o.customerDetails?.name ?? "").toLowerCase().includes(search.toLowerCase()) ||
            (o.categories ?? []).some(c => c.name.toLowerCase().includes(search.toLowerCase()));

        const matchCategory =
            categories.length === 0 ||
            categories.every(selected =>
                (o.categories ?? []).some(c => c._id === selected._id)
            );

        const orderDate = o.date ? new Date(o.date) : null;
        const matchStart = !startDate || (orderDate && orderDate >= new Date(startDate));
        const matchEnd = !endDate || (orderDate && orderDate <= new Date(endDate));

        return matchSearch && matchCategory && matchStart && matchEnd;
    });

    if (selectedOrder) {
        return <OrderDetailPage order={selectedOrder} onBack={() => setSelectedOrder(null)} />;
    }

    const totalRevenue = orders.reduce((sum, o) => sum + (o.finalTotal ?? 0), 0);

    return (
        <div style={s.page}>
            <main style={s.main}>
                {/* <h1 style={s.pageTitle}>{t("ConstructionOrderDashboard")} 🛒</h1> */}
                <div style={s.summaryStrip}>
                    <div style={s.summaryCard}>
                        <span style={{ ...s.summaryNum, color: "#3a6fa8" }}>{orders.length}</span>
                        <span style={s.summaryLbl}>Total Orders</span>
                    </div>
                    <div style={{ ...s.summaryCard, background: "#f0fdf4" }}>
                        <span style={{ ...s.summaryNum, color: "#059669", fontSize: 15 }}>{fmt(totalRevenue)}</span>
                        <span style={s.summaryLbl}>Total Revenue </span>
                    </div>
                </div>

                <div style={s.filtersRow}>
                    <input
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Search by Order No, Customer, Category ...."
                        style={s.searchInput}
                    />

                    <div style={{ flex: "1 1 220px", maxWidth: 340 }}>
                        <Select
                            placeholder="Select Categories"
                            options={categoryOptions}
                            isMulti
                            value={selectedOptions}
                            onChange={handleCategoryChange}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    minHeight: "38px",
                                    borderRadius: "8px",
                                    border: state.isFocused ? "1.5px solid #5b8fc9" : "1.5px solid #d1d5db",
                                    boxShadow: "none",
                                    background: "#fff",
                                    fontSize: "14px",
                                    color: "#374151",
                                    cursor: "pointer",
                                    "&:hover": { borderColor: "#5b8fc9" },
                                }),
                                placeholder: (base) => ({ ...base, color: "#9ca3af", fontSize: "14px" }),
                                multiValue: (base) => ({ ...base, background: "#eff6ff", borderRadius: "6px" }),
                                multiValueLabel: (base) => ({ ...base, color: "#3b82f6", fontSize: "13px", fontWeight: 500 }),
                                multiValueRemove: (base) => ({ ...base, color: "#3b82f6", "&:hover": { background: "#dbeafe", color: "#1d4ed8" } }),
                                option: (base, state) => ({
                                    ...base,
                                    background: state.isSelected ? "#3a6fa8" : state.isFocused ? "#eff6ff" : "#fff",
                                    color: state.isSelected ? "#fff" : "#374151",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                }),
                                menu: (base) => ({ ...base, borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.10)", border: "1.5px solid #d1d5db" }),
                            }}
                        />
                    </div>

                    {/* ── Date Range ── */}
                    <div style={s.dateRangeWrap}>
                        <div style={s.dateFieldWrap}>
                            <label style={s.dateLabel}>From</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                                style={s.dateInput}
                            />
                        </div>
                        <div style={s.dateFieldWrap}>
                            <label style={s.dateLabel}>To</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                                style={s.dateInput}
                            />
                        </div>
                        {(startDate || endDate) && (
                            <button
                                onClick={() => { setStartDate(""); setEndDate(""); }}
                                style={s.clearDateBtn}
                                title="Clear date filter"
                            >
                                ✕ Clear
                            </button>
                        )}
                    </div>
                </div>

                {loading ? (
                    <div style={s.loadWrap}>
                        <div style={s.spinner} />
                        <p style={{ color: "#9ca3af", marginTop: 12 }}>Loading orders…</p>
                    </div>
                ) : filtered.length === 0 ? (
                    <div style={s.empty}>No orders match your search.</div>
                ) : (
                    <div style={s.grid}>
                        {filtered.map(order => (
                            <OrderCard key={order._id} order={order} onClick={setSelectedOrder} />
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}

const s = {
    page: { minHeight: "100vh", background: "#f0f2f7", fontFamily: "'Segoe UI', system-ui, sans-serif" },
    nav: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 28px", height: 54, background: "#5b8fc9" },
    navBrand: { color: "#fff", fontWeight: 700, fontSize: 18 },
    navRight: { display: "flex", alignItems: "center", gap: 10 },
    langSelect: { padding: "5px 12px", borderRadius: 6, border: "1px solid rgba(255,255,255,0.4)", background: "rgba(255,255,255,0.15)", color: "#fff", fontSize: 13, cursor: "pointer" },
    navBtn: { padding: "6px 16px", borderRadius: 6, border: "none", background: "#3a6fa8", color: "#fff", fontWeight: 600, fontSize: 13, cursor: "pointer" },
    navBtnOutline: { padding: "6px 16px", borderRadius: 6, border: "1.5px solid rgba(255,255,255,0.5)", background: "transparent", color: "#fff", fontWeight: 600, fontSize: 13, cursor: "pointer" },
    main: { maxWidth: 1320, margin: "0 auto", padding: "30px 24px" },
    pageTitle: { textAlign: "center", fontSize: 24, fontWeight: 800, color: "#1e293b", marginBottom: 24 },
    pageSub: { textAlign: "center", color: "#64748b", fontSize: 14, marginTop: 6, marginBottom: 24 },
    summaryStrip: { display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 22 },
    summaryCard: { flex: "1 1 110px", background: "#fff", borderRadius: 10, padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", display: "flex", flexDirection: "column", alignItems: "center", gap: 2 },
    summaryNum: { fontWeight: 800, fontSize: 22 },
    summaryLbl: { fontSize: 11, color: "#6b7280", textAlign: "center" },
    filtersRow: { display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", marginBottom: 20, justifyContent: "space-between" },
    tabs: { display: "flex", flexWrap: "wrap", gap: 6 },
    tab: { padding: "6px 14px", borderRadius: 20, border: "1.5px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer", transition: "all .18s" },
    tabActive: { background: "#3a6fa8", color: "#fff", borderColor: "#3a6fa8" },
    grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: 18 },
    loadWrap: { display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 60 },
    spinner: { width: 36, height: 36, border: "4px solid #e5e7eb", borderTop: "4px solid #5b8fc9", borderRadius: "50%", animation: "spin 0.8s linear infinite" },
    empty: { textAlign: "center", color: "#9ca3af", paddingTop: 60, fontSize: 15 },
    card: { background: "#fff", borderRadius: 14, overflow: "hidden", transition: "transform .2s ease, box-shadow .2s ease", cursor: "pointer", userSelect: "none" },
    seqLabel: { margin: 0, fontSize: 10, color: "#9ca3af", letterSpacing: 1, textTransform: "uppercase" },
    seqNum: { margin: "2px 0 0", fontSize: 18, fontWeight: 800, color: "#1e293b" },
    badge: { display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 },
    customerName: { margin: "10px 0 2px", fontSize: 15, fontWeight: 600, color: "#374151" },
    catText: { margin: "0 0 8px", fontSize: 12, color: "#6b7280" },
    dateRow: { display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 },
    dateChip: { fontSize: 11, background: "#f1f5f9", color: "#475569", padding: "3px 8px", borderRadius: 6 },
    countRow: { display: "flex", gap: 6, marginBottom: 2 },
    countChip: { fontSize: 11, background: "#eff6ff", color: "#3b82f6", padding: "3px 8px", borderRadius: 6, fontWeight: 500 },
    divider: { borderTop: "1px solid #f1f5f9", margin: "12px 0" },
    financials: { display: "flex", justifyContent: "space-between", alignItems: "flex-end" },
    finLabel: { margin: 0, fontSize: 10, color: "#9ca3af", letterSpacing: 1 },
    finAmount: { margin: "3px 0 0", fontSize: 16, fontWeight: 800, color: "#1e293b" },
    backBtn: { display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 18px", borderRadius: 8, border: "1.5px solid #d1d5db", background: "#fff", color: "#374151", fontWeight: 600, fontSize: 14, cursor: "pointer", marginBottom: 20 },
    detailHeader: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", background: "#fff", borderRadius: 14, padding: "24px 28px", marginBottom: 16, boxShadow: "0 2px 10px rgba(0,0,0,0.07)", flexWrap: "wrap", gap: 16 },
    detailMeta: { margin: 0, fontSize: 11, color: "#9ca3af", letterSpacing: 1, textTransform: "uppercase" },
    detailTitle: { margin: "4px 0 0", fontSize: 26, fontWeight: 800, color: "#1e293b", display: "flex", alignItems: "center", flexWrap: "wrap" },
    detailSub: { margin: "6px 0 0", fontSize: 14, color: "#6b7280" },
    totalBox: { textAlign: "right", background: "#f8fafc", borderRadius: 10, padding: "14px 20px", minWidth: 200 },
    totalBoxLabel: { margin: 0, fontSize: 11, color: "#9ca3af", letterSpacing: 1 },
    totalBoxAmount: { margin: "4px 0 0", fontSize: 22, fontWeight: 800, color: "#1e293b" },
    infoGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 12, marginBottom: 16 },
    infoField: { background: "#fff", borderRadius: 10, padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    fieldLabel: { margin: 0, fontSize: 11, color: "#9ca3af", letterSpacing: 1, textTransform: "uppercase" },
    fieldValue: { margin: "4px 0 0", fontSize: 15, fontWeight: 700, color: "#1e293b" },
    section: { background: "#fff", borderRadius: 12, padding: "18px 20px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    sectionTitle: { margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#374151", textTransform: "uppercase", letterSpacing: 0.5 },
    catChip: { padding: "4px 12px", borderRadius: 20, background: "#eff6ff", color: "#3b82f6", fontSize: 13, fontWeight: 500 },
    tableWrap: { overflowX: "auto" },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { textAlign: "left", padding: "8px 12px", fontSize: 12, color: "#6b7280", fontWeight: 600, background: "#f8fafc", letterSpacing: 0.5 },
    td: { padding: "9px 12px", fontSize: 14, color: "#374151", borderBottom: "1px solid #f1f5f9" },
    summaryBox: { background: "#fff", borderRadius: 12, padding: "18px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", maxWidth: 420, marginLeft: "auto" },
    summaryRow: { display: "flex", justifyContent: "space-between", padding: "7px 0" },
    searchInput: { flex: "1 1 220px", maxWidth: 340, padding: "9px 14px", borderRadius: "8px", border: "1.5px solid #d1d5db", background: "#fff", fontSize: "14px", outline: "none", color: "#374151", height: "38px", boxSizing: "border-box", transition: "border-color 0.2s", },
    dateRangeWrap: { display: "flex", alignItems: "flex-end", gap: 8, flexWrap: "wrap", },
    dateFieldWrap: { display: "flex", flexDirection: "column", gap: 3, },
    dateLabel: { fontSize: 11, color: "#6b7280", fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase", },
    dateInput: { height: "38px", padding: "0 10px", borderRadius: "8px", border: "1.5px solid #d1d5db", background: "#fff", fontSize: "14px", color: "#374151", outline: "none", cursor: "pointer", boxSizing: "border-box", },
    clearDateBtn: { height: "38px", padding: "0 12px", borderRadius: "8px", border: "1.5px solid #fca5a5", background: "#fff", color: "#dc2626", fontSize: "12px", fontWeight: 600, cursor: "pointer", alignSelf: "flex-end", },
};

if (typeof document !== "undefined" && !document.getElementById("spin-style")) {
    const style = document.createElement("style");
    style.id = "spin-style";
    style.textContent = "@keyframes spin { to { transform: rotate(360deg); } }";
    document.head.appendChild(style);
}


const mapDispatchToProps = (dispatch) => {
    return {
        GetConstructionOrderApi: () => dispatch(GetConstructionOrderApi()),
        getCategoryData: () => dispatch(getCategoryData()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingConstructionOrder: state.ConstructionOrderReducer.isFetchingConstructionOrder,
    constructionOrderDataList: state.ConstructionOrderReducer.constructionOrderDataList,
    isFetchingcategoryList: state.CategoryReducer.isFetchingcategoryList,
    categoryList: state.CategoryReducer.categoryList,
});
export default connect(mapStateToProps, mapDispatchToProps)(ConstructionOrderDashboard);